export default "__VITE_ASSET__BSwUCqDm__"